import { faker } from '@faker-js/faker'

import { CouponTemplateStatus, CouponTemplateView } from '../../contracts/reward/CouponTemplate'
import { AdminCouponResponse, CouponDiscountCurrency, CouponDiscountType, CouponStatus } from '../../contracts/reward'

export const getCouponTemplateView = (): CouponTemplateView => {
  return {
    id: faker.string.uuid(),
    status: faker.helpers.enumValue(CouponTemplateStatus),
    content: {
      title: faker.lorem.sentence(),
      description: faker.lorem.sentence(),
    },
    discount: {
      couponDiscountType: faker.helpers.enumValue(CouponDiscountType),
      discountAmount: faker.number.int(),
      maxDiscountAmount: faker.number.int(),
      currency: faker.helpers.enumValue(CouponDiscountCurrency),
    },
    limit: {
      perPersonCount: faker.number.int(),
      totalCount: faker.number.int(),
    },
    minimumPaymentAmount: faker.number.int(),
    startIssuanceDatetimeUtc: faker.date.recent().toISOString(),
    endIssuanceDatetimeUtc: faker.date.recent().toISOString(),
    endExpiryPeriod: faker.number.int(),
    endExpiryDatetimeUtc: faker.date.recent().toISOString(),
    creator: faker.string.uuid(),
  }
}

export const getCoupon = (): AdminCouponResponse => {
  return {
    userId: faker.number.int(),
    userNickname: faker.lorem.word(),
    couponId: faker.lorem.word(),
    couponTemplateId: faker.lorem.word(),
    status: faker.helpers.enumValue(CouponStatus),
    title: faker.lorem.word(),
    endExpiryDateTimeUtc: faker.date.recent().toISOString(),
    discountType: faker.helpers.enumValue(CouponDiscountType),
    discount: faker.number.int(),
    maxDiscountAmount: faker.number.int(),
    currency: faker.lorem.word(),
    Enum: faker.helpers.enumValue(CouponDiscountCurrency),
    createdBy: faker.number.int(),
    updatedBy: faker.number.int(),
    createdAt: faker.date.recent().toISOString(),
    updatedAt: faker.date.recent().toISOString(),
  }
}
